import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../invoice.service';

@Component({
  selector: 'app-recent-pi',
  templateUrl: './recent-pi.component.html',
  styleUrls: ['./recent-pi.component.css']
})
export class RecentPiComponent implements OnInit {
  invoices : any = [];
  page=1;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  totalrecord:number;
  invoiceFilter: any = { paymentdate: '' };
  constructor(
    private invoiceService :InvoiceService, 
  ) { }

  ngOnInit() {
    this.getallRecentPaidInvoices();
  }


  getallRecentPaidInvoices() {
    return this.invoiceService.GetAllRecentPaidInvoices()
               .subscribe(
                invoice => {                 
                  this.invoices = invoice;
                  this.totalrecord = this.invoices.length;
         
                 }
                );
    }

    public onPageChange(pageNum: number): void {
      this.pageSize = this.itemsPerPage*(pageNum - 1);
    }
    
    public changePagesize(num: number): void {
    this.itemsPerPage = this.pageSize + num;
    }
    
}
